import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { LoadingService } from 'src/app/loading.service';
import { Events } from '../events';
import { EventsService } from '../events.service';
import { eventsValidator } from './events-validation.directive';

@Component({
  selector: 'app-new-event',
  templateUrl: './new-event.component.html',
  styleUrls: ['./new-event.component.css']
})
export class NewEventComponent {
  constructor(private formBuilder: FormBuilder, private eventssService: EventsService, private loadingService: LoadingService) {}

  selectedFile?: File = undefined
  fileName = '';

  eventsForm = this.formBuilder.group({
    name: [''],
    description: [''],
  }, {validators: eventsValidator})

  onSubmit() {
    const newEvent = ({uid: undefined, name: this.eventsForm.value.name, description: this.eventsForm.value.description }) as Events
    const loadingKey = newEvent.name
    this.loadingService.addLoadingKey(loadingKey)
    this.eventssService.addNewEvent(newEvent, loadingKey, this.selectedFile)
  }

  cancelClicked() {
    this.eventssService.addEventCancelled()
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      if (file.type == "image/png" || file.type == "image/jpeg") {
        this.fileName = file.name;
        this.selectedFile = file
      } else {
        alert(`Error: Invalid File Type - ${file.name}`)
        return
      }
    }
  }

  removeFile() {
    this.selectedFile = undefined
    this.fileName = ""
  }
}
